import Vue from 'vue';
import { Table } from 'ant-design-vue';
import styled from 'vue-styled-components';

import { ActionButton } from '@/components/Common/Dialog';

import { GRAY, square } from '@/styles/common.styled';
import {
    FLEX_VERTICAL_CENTER_DIV,
    FLEX_COLUMN_DIV,
} from '@/styles/common.styled.component';

export const ATable = styled(Vue.component('billing-table', Table))`
    width: 100%;
    padding-bottom: 32px;

    & thead th {
        border-top: 1px solid #eee;
        color: ${GRAY(40)};
        font-size: 14px;
        font-weight: normal;
    }

    & tbody td {
        color: ${GRAY(100)};
        vertical-align: middle;
    }
`;

export const EditTrashIconWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    & > svg {
        ${square(18)};
        &:hover {
            cursor: pointer;
        }
        &.edit-icon,
        &.trash-icon,
        &.duplicate-icon {
            margin-right: 14px;
        }
    }
`;

const getItemsPerPageText = (locale) => {
    if (locale === 'ko') {
        return '페이지당 항목 수';
    }

    if (locale === 'ja') {
        return '１ページあたりの項目数';
    }
    return 'Items per page';
};

export const TableWrapper = styled(FLEX_COLUMN_DIV, {
    locale: String,
})`
    .ant-table-pagination {
        display: flex;
        flex-direction: row;
        align-items: center;

        .ant-pagination-options {
            order: -1;
            display: flex;
            align-items: center;
            margin-right: 30px;

            &::before {
                content: '${(props) => getItemsPerPageText(props.locale)}';

                color: #949aa1;

                /* Number/12-400 */
                font-family: var(--font-family-primary);
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 12px; /* 100% */
                letter-spacing: -0.3px;
                margin-right: 8px;
            }
        }

        .ant-select-selection__rendered {
            display: flex;
            align-items: center;
        }

        .ant-select-selection-selected-value {
            color: #949aa1;

            /* Number/12-400 */
            font-family: var(--font-family-primary);
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 12px; /* 100% */
            letter-spacing: -0.3px;
        }
    }
`;

export const DbIcon = styled.div`
    height: 30px;
    width: auto;
    margin-right: 12px;
    & svg {
        height: 30px;
        width: auto;
    }
`;

export const NameWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: fit-content;
    max-width: 500px;
`;

export const DestinationWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: fit-content;
    & > svg,
    img {
        margin-right: 12px;
        ${square(30)};
        flex-shrink: 0;
    }
`;

export const ChnnelIconsWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    min-width: 80px;
    & svg,
    .adverity-icon {
        margin-right: 4px;
        ${square(16)};
    }
`;

export const UpdatedWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex-shrink: 0;
    svg {
        margin-left: 4px;
        cursor: pointer;
        flex-shrink: 0;
    }
`;

export const SearchInputWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: 100%;
    padding: 24px 0 40px 0;
`;

// The field itself is Common/searchInput (TASK-14078); this only places it.
export const SearchInputContainer = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-left: auto;

    .search-input {
        width: 240px;
    }
`;

export const GotoApiCenterButton = styled(ActionButton)`
    width: unset;
    min-width: unset;
    height: 36px;
    gap: 4px;
    padding: 0 12px 0 8px;
    border-radius: 8px;
    border: 1px solid #d9dee3;

    & > span {
        color: #3c464f;
        font-size: 13px;
        font-weight: 500;
        line-height: 20px;
    }
`;
